<template lang="html">
  <div class="container-fluid">
         <div class="col-md-10 order-md-1">
          <h4 class="mb-3">Contact information</h4>
          
<form v-on:submit.prevent="updatecontact">
  <div class="form-row">
    <div class="form-group col-md">
      <label for="firstname">First Name</label>
      <input type="text" class="form-control" id="firstname" placeholder="First Name" v-model="firstname">
    </div>
    <div class="form-group col-md">
      <label for="lastname">Last Name</label>
      <input type="text" class="form-control" id="lastname" placeholder="Last Name" v-model="lastname">
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md">
      <label for="dob">Date of Birth</label>
      <input type="date" class="form-control" id="dob" v-model="dob">
    </div>

    <div class="form-group col-md">
      <label for="inlineFormCustomSelectPref">Gender</label>
        <select class="custom-select" id="inlineFormCustomSelectPref" v-model="gender">
            <option selected>Choose...</option>
          <option value="Female">Female</option>
          <option value="Male">Male</option>
        </select>
    </div>
  </div>
<div class="form-group col-md">
  <div class="form-row">
    <div class="col">
      <div class="form-group col-md">
      <h4>Current</h4>
      <label for="currentinc">Current Income (Monthly)</label>
      <input type="number" v-model="currentinc" class="form-control" id="currentinc" placeholder="Current Income" aria-describedby="validationTooltipUsernamePrepend">
      </div>
      <div class="form-group col-md">
        <label for="currentsav">Current Savings (Monthly)</label>
        <input type="number" v-model="currentsav" class="form-control" id="currentsav" placeholder="Current Savings" aria-describedby="validationTooltipUsernamePrepend">
      </div>
    </div>
<div class="col">
  <div class="form-group col-md">
    <h4>Retirement</h4>
     <label for="retirmentage">Retirement Age</label>
      <input type="number" min="0" max="100" step="1" v-model="retireage" class="form-control" id="retirementage" placeholder="Retirement Age" aria-describedby="validationTooltipUsernamePrepend">
      </div>
      <div class="form-group col-md">
     <label for="retirementinc">Retirement Income (Monthly)</label>
  <input type="number" v-model="retireinc" class="form-control" id="retirementinc" placeholder="Retirement Income" aria-describedby="validationTooltipUsernamePrepend">
  </div>
  <div class="form-group col-md">
     <label for="retirementinc">Retirement Spending (Monthly)</label>
  <input type="number" v-model="retirespend" class="form-control" id="retirementspend" placeholder="Retirement Spending" aria-describedby="validationTooltipUsernamePrepend">
  </div>
</div>
  </div>
</div>

  <button type="submit" class="btn btn-primary">Update Contact</button>
</form>
            </div>
    <div>
  </div>
  </div>
</template>

<script>
import router from '../router.js'
import db from './firebaseInit'
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/firestore');

export default {
  name: 'editcontactinfo',
  data () {
    return {
      firstname: null,
      lastname: null,
      gender: null,
      dob: null,
      retireage: null,
      retireinc: null,
      retirespend: null,
      currentinc: null,
      id: null
    }
  },
  beforeRouteEnter (to, from, next) {

    var userId
  var user = firebase.auth().currentUser;
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('contacts').where('fullnamecode','==', to.params.contact_id).get()
  .then(querySnapshot => {
    querySnapshot.forEach(doc => {
      next(vm => {
        vm.id = doc.id,
        vm.firstname = doc.data().firstname,
        vm.lastname = doc.data().lastname,
        vm.gender = doc.data().gender,
        vm.retireage = doc.data().retireage,
        vm.retirespend = doc.data().retirespend,
        vm.retireinc = doc.data().retireinc,
        vm.currentinc = doc.data().currentinc,
        vm.currentsav = doc.data().currentsav,
        vm.dob = doc.data().dob
      })
    })
  })
  },
  watch: {
'$route' : 'loaddata'
  },
  created: function(){
   
  
  },
  mounted: function(){
   this.loaddata()
  },
  methods: {
  loaddata: function(){
    var userId

  var user = firebase.auth().currentUser;
   if (user != null) {
      userId = user.uid;
      } 

    
  db.collection('users').doc(userId).collection('contacts').where('fullnamecode','==', this.$route.params.contact_id).get().then
  (querySnapshot => {

    querySnapshot.forEach(doc => {
        this.id = doc.id,
        this.firstname = doc.data().firstname,
        this.lastname = doc.data().lastname,
        this.gender = doc.data().gender,
        this.retireage = doc.data().retireage,
        this.retireinc = doc.data().retireinc,
        this.retirespend = doc.data().retirespend,
        this.currentinc = doc.data().currentinc,
        this.currentsav = doc.data().currentsav,
        this.dob = doc.data().dob
       
      
    }) 
  }
  )
  
    },
    updatecontact: function(){
  var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
      
  db.collection('users').doc(userId).collection('contacts').doc(this.id).set({
    firstname: this.firstname,
    lastname: this.lastname,
    gender: this.gender,
    dob: this.dob,
    retireage: this.retireage,
    retireinc: this.retireinc,
    retirespend: this.retirespend,
    currentinc: this.currentinc,
    currentsav: this.currentsav,
    retireyear: Number(this.retireage) + Number(this.dob.substring(0,4)),
    fullnamecode: this.firstname + '_' + this.lastname
 
  }).then( ref =>{
    router.push({path: '/info'})
  })
  
}

  },
  computed: {
  }

}
</script>